<h2 mat-dialog-title>Select Funding Source</h2>
<mat-dialog-content>
  <div class="hpac-banner" *ngIf="data.isHpac">
    <mat-icon>info</mat-icon>
    <span>HPAC client. Fee For Service is required.</span>
  </div>

  <mat-radio-group [(ngModel)]="selectedBudgetTypeId" class="funding-radio-group">
    <mat-radio-button *ngFor="let fs of data.fundingSources"
                     [value]="fs.BudgetTypeID"
                     class="funding-option">
      <span class="funding-label">
        {{ fs.Description }}
        <span class="funding-budget-desc" *ngIf="fs.BudgetDescription"> &mdash; {{ fs.BudgetDescription }}</span>
      </span>
      <span class="recommended-badge" *ngIf="fs.BudgetTypeID === data.recommendedBudgetTypeId">Recommended</span>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSelect()">Select</button>
</mat-dialog-actions>
